import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "force_play",
  "use": "force_play-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"force_play\"><path d=\"M15.55 7.95 7.5 2.09a.942.942 0 0 0-1.5.77v5.39H3.5V2H2v14h1.5V9.75H6v5.39c0 .77.88 1.22 1.5.77l8.05-5.85a1.3 1.3 0 0 0 0-2.11\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol